import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { showErrors } from '../../modules/general';
import { apiFetch, apiSearch } from '../../modules/utility';
const apiBase = 'candoBol';

const mapStateToProps = (state, ownProps) => {
	let candoBols;
	let candoBol;
	let candoBolId;

	if (state.lists.candoBolIds) {
		candoBols = _.map(state.lists.candoBolIds, (id) => state.maps.candoBol[id]);
	}

	if (ownProps.candoBol) {
		candoBol = ownProps.candoBol;
	} else {
		candoBolId = ownProps.candoBolId
			? ownProps.candoBolId
			: _.get(ownProps, ['match', 'params', 'candoBolId']);
		candoBol = _.get(state.maps, ['candoBol', candoBolId]);
	}

	return {
		candoBol,
		candoBols,
		authUser: state.auth.authUser,
		userMap: state.maps.user,
		resourceMap: state.maps.resource,
		stationDeliveryMap: state.maps.stationDelivery,
		stationMap: state.maps.station,
		terminalMap: state.maps.terminal,
	};
};

const search = (p = {}) => {
	const { afterDateTime, bolNumber, callback = _.noop } = p;
	return (dispatch) => {
		apiSearch({
			base: apiBase,
			params: {
				afterDateTime,
				bolNumber,
			},
			dispatch,
			callback,
		});
	};
};

const uploadBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.uploadBol`,
			params,
			dispatch,
			callback,
		});
	};
};

const reparseBol = ({ params, callback = _.noop }) => {
	return (dispatch) => {
		apiFetch({
			method: `${apiBase}.reparse`,
			params,
			dispatch,
			callback,
		});
	};
};

const mapDispatchToProps = (dispatch) =>
	bindActionCreators(
		{
			candoBolSearch: search,
			candoBolUpload: uploadBol,
			candoBolReparse: reparseBol,
			showErrors,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps);
